import { RouteFragment } from '../enums/route-fragment';
import { RedirectFunction } from '@angular/router';
import { isEmptyObject, queryParamsStringify } from '@web/utils';

export const routeFragmentWithQueryParamsPreserve = (
  fragment: RouteFragment,
): RedirectFunction => {
  return (redirectData) => {
    const { queryParams } = redirectData;

    if (isEmptyObject(queryParams)) {
      return fragment;
    }

    return `${fragment}?${queryParamsStringify(queryParams)}`;
  };
};
